"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            programs: null,
            categories: []
        };
    },
    onMount: function () {
        this.fetchPrograms();
    },
    onFilterByCategories: function (list) {
        this.state.categories = list;
        this.setStateDirty('categories');
    },
    fetchPrograms: async function () {
        try {
            const {error, message, results} = await Request('/program/list');
            if (error)
                console.log('Error Fetching Programs: ', message);
            this.state.programs = results || [];
        } catch (error) {
            console.log('Error Fetching Programs');
            this.state.programs = null;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    CategoryFilters_template = require("../../components/CategoryFilters.marko"),
    CategoryFilters_tag = marko_loadTag(CategoryFilters_template),
    SortListControl_template = require("../../../components/SortListControl/index.marko"),
    SortListControl_tag = marko_loadTag(SortListControl_template),
    DoSearch_template = require("../../../components/DoSearch/index.marko"),
    DoSearch_tag = marko_loadTag(DoSearch_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_Program_template = require("../../components/Card-Program.marko"),
    Card_Program_tag = marko_loadTag(Card_Program_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6aa3d1"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("img", {
        src: "/images/illustration/create-course.png",
        "class": "img-fluid",
        alt: "illustration"
      }, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "filters"
      },
    marko_node4 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        id: "programs-list",
        "class": "mt-1"
      },
    marko_node5 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "mx-1"
      },
    marko_attrs5 = {
        "class": "col"
      },
    marko_attrs6 = {
        "class": "col text-right"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { page, themeMode }) {
        if (state.programs == null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.programs.length) {
          out.be("div", marko_attrs0, "2", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("h5", null, "5", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Create, Manage and Share your programs");
                          }
                        }, out, __component, "6");

                      out.ee();

                      out.n(marko_node0, component);

                      out.be("p", marko_attrs1, "8", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Group multiple courses and activities to create a program: It's that simple. Check our");
                          }
                        }, out, __component, "9");

                      out.t(" ");

                      route_link_tag({
                          href: "/templates/programs",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Program Templates"
                              }, out, __component, "11");
                          }
                        }, out, __component, "10");

                      out.t(" ");

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("if you're new to it, for learning and customizing professional programs. If you are already a Pro or curios, you can start by creating your program from scratch.");
                          }
                        }, out, __component, "12");

                      out.ee();

                      out.n(marko_node1, component);

                      out.n(marko_node2, component);

                      route_link_tag({
                          class: "btn btn-primary btn-lg m-25",
                          href: "/create-program",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Create from Scratch"
                              }, out, __component, "16");
                          }
                        }, out, __component, "15");
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    class: "col text-center",
                    renderBody: function(out) {
                      out.n(marko_node3, component);
                    }
                  }, out, __component, "17");
              }
            }, out, __component, "3");

          out.ee();
        } else {
          out.be("section", marko_attrs2, "19", component);

          CategoryFilters_tag({
              target: "programs"
            }, out, __component, "20", [
            [
              "init",
              "onFilterByCategories",
              false
            ],
            [
              "change",
              "onFilterByCategories",
              false
            ]
          ]);

          out.n(marko_node4, component);

          Row_tag({
              class: "m-0 icons d-flex align-items-center mx-1",
              renderBody: function(out) {
                out.be("div", marko_attrs5, "23", component);

                SortListControl_tag({}, out, __component, "24");

                DoSearch_tag({
                    target: "programs"
                  }, out, __component, "25");

                out.ee();

                out.be("div", marko_attrs6, "26", component);

                route_link_tag({
                    href: "/create-program",
                    class: "btn btn-primary btn-lg",
                    renderBody: function(out) {
                      Locale_tag({
                          text: "Add a Program"
                        }, out, __component, "28");
                    }
                  }, out, __component, "27");

                out.ee();
              }
            }, out, __component, "22");

          out.ee();

          out.be("section", marko_attrs3, "29", component);

          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                marko_forOf(state.programs, function(program, index) {
                  if ( !state.categories.length
              || !Array.isArray( program.categories )
              || !program.categories.length
              || program.categories.filter( ({ name }) => { return state.categories.includes( name ) } ).length ) {
                    Card_Program_tag(program, out, __component, index);
                  }
                });
              }
            }, out, __component, "30");

          out.n(marko_node5, component);

          out.be("div", marko_attrs4, "32", component);

          route_link_tag({
              href: "/create-program",
              class: "btn btn-primary btn-lg",
              renderBody: function(out) {
                Locale_tag({
                    text: "Add a Program"
                  }, out, __component, "34");
              }
            }, out, __component, "33");

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
